enum NotificationChannel_Enum {
    None = 0,
    Push = 1 << 0,
    Email = 1 << 1,
    Sms = 1 << 2,
    WhatsApp = 1 << 3,
    All = Push | Email | Sms | WhatsApp
}

interface BaseScenarioDetails {
	channel: NotificationChannel_Enum | undefined;
}

export default NotificationChannel_Enum;
export { BaseScenarioDetails };